export class GenerateIdentifierParams {
  collection_id: string;
  superobject_type_id: string;
  context_id: string;
}
